import React from 'react';
import ButtonLink from '../ui/Buttons/ButtonLink';
import { GatsbyImage } from "gatsby-plugin-image";
import Section from '../ui/Section/Section';
import Carousel from '../ui/Carousel/Carousel';
import { IBlockFallbeispielReferences } from './IBlocks';

type Props = {
    id?: string;
}

export default function FallbeispieleReferences (props: Props & IBlockFallbeispielReferences) {
    const {references, title, id } = props;

    return (
        <Section  id={id} hasTitle={true}>
            <div className="container">
                {title && <div className="content">
                    <h3 className="title">{title}</h3>
                </div>}
                <div className="columns is-multiline">
                    

                    <div className="column">

                        <Carousel
                            subPages={references.map((node) => {
                                        const to = "/fallbeispiele/" + node.url;
                                        return <div key={to}>
                                            <h3 className="title is-4">{node.name}</h3>
                                             <p>{node.kurzbeschreibung}</p>
                                            <ButtonLink to={to} variation={"minimal"}>Zum Fallbeispiel</ButtonLink>
                                        </div>
                            })}
                            >
                            {references.map((node) => {
                                const to = "/fallbeispiele/" + node.url; 
                                return (
                                    <div key={to}>
                                            <GatsbyImage
                                                image={{...node.listenbild.src.childImageSharp.gatsbyImageData, aspectRatio: 1.6 }}
                                                alt={node.listenbild.alt}
                                                title={node.listenbild.alt} />
                                    </div>
                                );
                        })}
                        </Carousel>

                    </div>
                   

                </div>
            </div>
        </Section>
    );
    

}